const LOOM_EMBED_QUERY_KEYS = [
  "sid",
  "t",
  "autoplay",
  "muted",
  "hide_share",
  "hideEmbedTopBar",
  "hide_title",
  "hide_owner",
  "hide_speed",
] as const;
const TELLA_EMBED_QUERY_KEYS = [
  "b",
  "title",
  "a",
  "loop",
  "t",
  "muted",
  "wt",
] as const;
const YOUTUBE_EMBED_QUERY_KEYS = ["start"] as const;
const VIDEO_EMBED_QUERY_VALUE_MAX_LENGTH = 256;

/** Keeps only documented player parameters in a stable query string. */
export function normalizeEmbeddedVideoQuery(
  provider: string,
  value: unknown,
): string {
  if (provider === "clip") return "";
  if (typeof value !== "string" || !value.trim()) return "";
  const input = new URLSearchParams(
    value.trim().replace(/^\?/, "").split("#", 1)[0],
  );
  const output = new URLSearchParams();
  const keys =
    provider === "youtube"
      ? YOUTUBE_EMBED_QUERY_KEYS
      : provider === "tella"
        ? TELLA_EMBED_QUERY_KEYS
        : LOOM_EMBED_QUERY_KEYS;
  for (const key of keys) {
    const parameterValue = input.get(key);
    if (
      parameterValue !== null &&
      parameterValue.length <= VIDEO_EMBED_QUERY_VALUE_MAX_LENGTH
    ) {
      output.set(key, parameterValue);
    }
  }
  return output.toString();
}
